import { IS_TEST } from '@/shared/const';
import { useMutation } from '@tanstack/react-query';
import { profileUpdater, sendEvent, setConfig, setMeta, setProfile } from '@sbol/clickstream-agent';
import { getHashUserLoginId } from '../lib/utils';
import { getParams } from '../api/clickstreamParamsQuery';

setConfig({
    reportUrl: 'https://ext.clickstream.sberbank.ru/metrics/ecosystem/sberinsur',
});

setMeta({
    apiKey: IS_TEST
        ? '637e180f931cc8ebd2937f726c9d7c11ad8a6264d49e808a0be0f307f16eb587'
        : 'b960b139f9bd987cde8f63bf5f78c37522f4993888735076ed1dcfd9299810ce',
});

const hashUserLoginId = getHashUserLoginId();

setProfile({
    hashUserLoginId,
    appVersion: '1.0',
});

export const useClickstreamParams = () => {
    return useMutation({
        mutationFn: getParams,
        onSuccess: ({ provider, sub, uuid }) => {
            if (provider) {
                setProfile({
                    clientBlock: provider,
                    hashUserLoginId,
                    appVersion: '1.0',
                });
            }

            profileUpdater.setProfileID('sbClientId', sub, false);
            profileUpdater.setProfileID('clientId', uuid, false);
        },
        onSettled: () => {
            sendEvent({
                eventCategory: 'sberinsur',
                eventAction: 'Открытие Квадратные метры',
                value: '',
            });
        },
        retry: false,
    });
};
